import React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const philosophyItems = [{
  title: "Empathy & Understanding",
  description: "We recognize the heavy emotional and financial weight of a timeshare burden. Our team treats every client's situation with the personal care and sensitivity it deserves, listening to your story before acting."
}, {
  title: "Proven Legal Expertise",
  description: "Navigating complex timeshare contracts requires specialized knowledge. We bring decades of professional authority and deep industry insight to the table, ensuring your exit strategy is robust and effective."
}, {
  title: "Absolute Transparency",
  description: "Trust is our foundation. We provide clear, honest paths forward with no hidden agendas or false promises—just straightforward guidance and a commitment to helping you regain your financial freedom."
}];
export default function OurPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="42231" id="rooted-in-integrity" className="bg-background py-24 px-8 text-foreground" ref={ref}>
      <div className="max-w-4xl mx-auto">
        <h2 className={cn("font-default text-4xl md:text-5xl text-center mb-20 text-primary transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
          Rooted in Integrity
        </h2>

        <div className="flex flex-col gap-12">
          {philosophyItems.map((item, i) => <div key={i} data-index={i} className={cn("flex gap-6 md:gap-8 items-start transition-all duration-700 ease-out shadow-sm rounded-xl", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="shrink-0 mt-1.5">
                <div className="flex items-center justify-center size-8 rounded-full bg-secondary/10">
                  <Check className="size-5 text-secondary" strokeWidth={3} />
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="font-default text-[32px] leading-tight text-primary">
                  {item.title}
                </h3>
                <p className="font-sans text-lg md:text-xl leading-[1.6] text-muted-foreground">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}